export default {
  title: 'Se connecter',
  login: 'Adresse email',
  loginWarning: 'Veuillez renseigner un identifiant',
  password: 'Mot de passe',
  passwordWarning: 'Veuillez renseigner un mot de passe',
  loginSubmit: 'Se connecter',
};
